
const contactUsUrl = 'https://www.zikaronbasalon.com/contact/';

export default contactUsUrl;